import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";

@Component({
  selector: "app-icon-svg",
  templateUrl: "./icon-svg.component.html",
  styleUrl: "./icon-svg.component.scss",
  imports: [CommonModule],
})
export class IconSvgComponent {
  @Input() classes = "";
  @Input({ required: true }) icon!: string;
}
